var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEditEvent = function SvgEditEvent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 27.021"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".edit-event_svg__st0{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit-event_svg__bfb4cacb-8dff-4949-92f1-051d287b5229",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edit-event_svg__e19d263a-817d-4714-a93d-475f4be0ee5c",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.811 23.5H1.5a1 1 0 0 1-1-1v-19a1 1 0 0 1 1-1h19a1 1 0 0 1 1 1V12M3.5.5V5M8.5.5V5M13.5.5V5M18.5.5V5",
    className: "edit-event_svg__st0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.5 7.5-3 3L4 9M8.5 13l-3 3L4 14.5M10.5 9.5H17M10.5 14.5H17M17.7 25.321l-4.2 1.2 1.2-4.2 7.179-7.179a2.121 2.121 0 1 1 3 3ZM20.979 16.042l3 3",
    className: "edit-event_svg__st0"
  })))));
};
export default SvgEditEvent;